import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Popover } from '@material-ui/core';
import { InfoIcon } from '../../icons';
import { AGGREGATE_STATUS } from '../../constants';
import AggregatesPopup from './components/AggregatesPopup/AggregatesPopup';

const AggregateStatusIndicator = ({
  rowData,
  currentAggregate: currentMaterialGroup,
  fontSize = '1.5em',
  style: infoIconStyle = {},
}) => {
  const { materialGroupClusters, hasUnAvailableAggregates } = rowData;
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const iconRef = useRef(null);

  const otherSimplifiedMaterialsGroupClusters = materialGroupClusters
    .filter(
      (materialGroupCluster) =>
        materialGroupCluster.name !== currentMaterialGroup
    )
    .map((group) => ({
      name: group.name,
      materials: [...group.materials],
    }));

  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);

  const greenColor = '#49a47e';
  const redColor = '#F17C7C';
  const greyColor = '#7070708c';

  let fillColor = greyColor;

  const isAvailable = (status) =>
    AGGREGATE_STATUS.BOOKED === status ||
    AGGREGATE_STATUS.READY_FOR_PICKUP === status;

  const allMaterials = otherSimplifiedMaterialsGroupClusters.flatMap(
    (materialGroup) =>
      materialGroup.materials.map((material) => ({
        ...materialGroup,
        ...material,
      }))
  );

  if (hasUnAvailableAggregates) fillColor = redColor;
  else if (
    allMaterials.every((material) => isAvailable(material.aggregateStatus))
  )
    fillColor = greenColor;

  return (
    <>
      <InfoIcon
        style={{ color: fillColor, fontSize, ...infoIconStyle }}
        ref={iconRef}
        onClick={openPopup}
      />
      <Popover
        open={isPopupOpen}
        anchorEl={iconRef.current}
        onClose={closePopup}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
      >
        <AggregatesPopup
          materials={otherSimplifiedMaterialsGroupClusters}
          vc={rowData.vc}
        />
      </Popover>
    </>
  );
};

AggregateStatusIndicator.propTypes = {
  rowData: PropTypes.shape({
    vc: PropTypes.string.isRequired,
    materialGroupClusters: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        materials: PropTypes.arrayOf(
          PropTypes.shape({
            material: PropTypes.string.isRequired,
            status: PropTypes.string.isRequired,
            comment: PropTypes.string,
            modifiedAt: PropTypes.string,
            aggregateStatus: PropTypes.string.isRequired,
            aggregateModifiedAt: PropTypes.string,
            aggregateComment: PropTypes.string,
          })
        ).isRequired,
      })
    ).isRequired,
    hasUnAvailableAggregates: PropTypes.bool.isRequired,
  }).isRequired,
  fontSize: PropTypes.string,
  style: PropTypes.object,
  currentAggregate: PropTypes.string.isRequired,
};

export default AggregateStatusIndicator;
